import BaseModal from 'components/atoms/base-modal';
import BaseRichTextEditor from 'components/atoms/base-rich-text-editor';
import { useTranslation } from 'react-i18next';
import BaseButton from 'components/atoms/baseButton';
import { useFormik } from 'formik';
import { isHtmlEmpty } from 'utils';
import { parseDateSafe } from 'utils/timeHelper';

import s from './styles.module.scss';
import { ExpiredDatePicker } from '../expired-date';

import type { ICreateOrUpdate } from '../types';
import type { ModuleType } from 'infrastructure/enums';
import type { IKeyNoteData } from 'infrastructure/interfaces';

interface IProps {
  note?: IKeyNoteData | null;
  isOpen: boolean;
  moduleType: ModuleType;
  onSave: (values: ICreateOrUpdate) => void;
  onCancel: () => void;
  isLoading?: boolean;
}
export const CreateOrUpdateKeyNoteModal = ({
  note,
  isOpen,
  moduleType,
  isLoading,
  onCancel,
  onSave,
}: IProps) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      note: note?.note || '',
      expiresAt: parseDateSafe(note?.expiresAt) || null,
      module: moduleType,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      onSave(values);
      formik.resetForm();
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    onCancel();
  };

  return (
    <BaseModal
      onCancel={handleCancel}
      bodyClassNames={s['create-custom-style']}
      title={t(`labels.${note ? 'editKeynote' : 'addNewKeynote'}`)}
      zIndex={3001}
      width={1000}
      open={isOpen}
    >
      <div className={s['create-modal-content']}>
        <BaseRichTextEditor
          value={formik.values.note}
          setValue={(v) => formik.setFieldValue('note', v)}
          disabled={false}
        />
      </div>
      <div className={s['create-modal-footer-wrapper']}>
        <ExpiredDatePicker
          expiresDate={formik.values?.expiresAt}
          onChangeDate={(d) => formik.setFieldValue('expiresAt', d)}
        />
        <div className={s['create-modal-footer-actions']}>
          <BaseButton
            disabled={isLoading}
            onClick={handleCancel}
            type="secondary"
            label={t('labels.cancel')}
          />
          <BaseButton
            loading={isLoading}
            disabled={isHtmlEmpty(formik.values.note)}
            onClick={() => formik.handleSubmit()}
            label={note ? t('labels.save') : t('labels.addKeynote')}
          />
        </div>
      </div>
    </BaseModal>
  );
};
